import { ListItemText } from 'appkit-react';
import { useMutation } from '@apollo/client';

// eslint-disable-next-line import/no-unresolved
import { UPDATE_PROJECT } from 'Apollo/Mutations/DataRecon';

const ArchiveProject = ({
    project, fetchData, setToastMessage,
}) => {
    /* apollo mutation to update the project */
    const [archiveProject] = useMutation(UPDATE_PROJECT);

    /* callback function called on click of Archive option */
    const fetchProjectData = async () => {
        if (project.status === 'archived') {
            await archiveProject({
                variables: {
                    input: {
                        projectId: parseInt(project.projectId, 10),
                        projectName: project.projectName,
                        projectDesc: project.projectDesc,
                        ownerId: parseInt(project.ownerId, 10),
                        status: 'open',
                        parentProjectId: parseInt(project.parentProjectId, 10),
                        userIdArr: project.userIdArr,
                    },
                },
            }).then(() => setToastMessage('Project is open.'));
            fetchData();
        } else {
            await archiveProject({
                variables: {
                    input: {
                        projectId: parseInt(project.projectId, 10),
                        projectName: project.projectName,
                        projectDesc: project.projectDesc,
                        ownerId: parseInt(project.ownerId, 10),
                        status: 'archived',
                        parentProjectId: parseInt(project.parentProjectId, 10),
                        userIdArr: project.userIdArr,
                    },
                },
            }).then(() => setToastMessage('Project is archived.'));
            fetchData();
        }
    };

    return (
        <div>
            <ListItemText onClick={fetchProjectData}>
                {project.status === 'archived' ? 'Unarchive' : 'Archive'}
            </ListItemText>
        </div>
    );
};

export default ArchiveProject;
